<ng-container [ngSwitch]="workflowStatus">
    <span *ngSwitchCase="WorkflowStatusEnum.Completed">Completed {{completionDate | timeAgo}} by {{completedBy}}</span>
    <span *ngSwitchCase="WorkflowStatusEnum.Current">Started {{startDate | timeAgo}} by {{startedBy}}</span>
</ng-container>
